import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { STARRED_PROJECTS } from '@/store/modules/project/mutation-types';
export default _defineProperty({}, STARRED_PROJECTS, function (state, payload) {
  state[STARRED_PROJECTS] = payload;
});